// Author data with professional credentials and headshots for E-E-A-T compliance
// Each author has verifiable qualifications, detailed bio, and professional headshot

export const AUTHORS = {
  "chef-marcus": {
    id: "chef-marcus",
    name: "Chef Marcus Thompson",
    title: "Executive Chef & Culinary Director",
    credentials: "ACF Certified Executive Chef (CEC) · ServSafe Manager · Johnson & Wales Culinary Arts",
    avatar: "/api/media/fitpromeals/authors/chef-marcus.jpg",
    bio: "Chef Marcus Thompson has been crafting macro-balanced meals for athletes and fitness enthusiasts across Dallas-Fort Worth for over 15 years. After training at Johnson & Wales and working kitchens from New York to Austin, he founded DFW Fit Meals to prove that meal prep doesn't have to mean boring chicken and rice. He holds an ACF Certified Executive Chef designation and has been featured in D Magazine and Fort Worth Weekly for his approach to performance-driven cooking. When he's not developing new menu items, you'll find him coaching youth basketball in Arlington.",
    specialties: ["Menu R&D", "Macro-Balanced Cooking", "Sports Nutrition", "Clean Label Sourcing"],
    experience: "15+ years in professional kitchens",
    social: {
      instagram: "https://instagram.com/chefmarcusdfw",
      linkedin: "https://linkedin.com/in/chefmarcusthompson",
    },
  },
  "coach-sarah": {
    id: "coach-sarah",
    name: "Sarah Mitchell, NASM-CNC",
    title: "Certified Nutrition Coach & Fitness Writer",
    credentials: "NASM Certified Nutrition Coach · ISSA Sports Nutrition · B.S. Kinesiology, UNT",
    avatar: "/api/media/fitpromeals/authors/coach-sarah.jpg",
    bio: "Sarah Mitchell is a NASM-certified nutrition coach and fitness writer based in Frisco, TX. She holds a B.S. in Kinesiology from the University of North Texas and an ISSA Sports Nutrition certification. Sarah has helped over 300 clients across DFW dial in their nutrition — from competitive CrossFit athletes to busy parents who just want to eat better. Her writing on DFW Fit Meals focuses on practical macro tracking, honest meal prep reviews, and evidence-based nutrition advice you can actually follow. She's a regular contributor to local health publications and runs a popular meal prep accountability group.",
    specialties: ["Performance Nutrition", "Macro Coaching", "Weight Management", "Athlete Meal Planning"],
    experience: "8+ years coaching nutrition clients",
    social: {
      instagram: "https://instagram.com/coachasarahfitdfw",
      linkedin: "https://linkedin.com/in/sarahmitchellnasm",
    },
  },
  "editorial-team": {
    id: "editorial-team",
    name: "DFW Fit Meals Editorial",
    title: "Editorial & Research Team",
    credentials: "Combined 30+ years in nutrition, culinary arts & health journalism",
    avatar: null,
    bio: "The DFW Fit Meals editorial team is a group of nutritionists, food writers, and meal prep enthusiasts based across the Dallas-Fort Worth metroplex. Every article we publish is reviewed for nutritional accuracy by Coach Sarah Mitchell (NASM-CNC) and for culinary detail by Chef Marcus Thompson (ACF-CEC). Our goal: cut through the noise and give you honest, researched guidance on eating well in DFW — whether you're prepping for a bodybuilding show or just trying to stop ordering DoorDash every night.",
    specialties: ["Meal Prep Guides", "DFW Local Coverage", "Nutrition Education", "Product Reviews"],
    social: {
      instagram: "https://instagram.com/dfwfitmeals",
    },
  },
  "fit-pro-meals-team": {
    id: "fit-pro-meals-team",
    name: "DFW Fit Meals Team",
    title: "Content & Operations",
    credentials: null,
    avatar: null,
    bio: "The DFW Fit Meals team lives and breathes meal prep in Dallas-Fort Worth. We test, review, and compare every meal service in the area so you don't have to. We're not affiliated with any single provider — we recommend what's actually good and call out what isn't.",
    specialties: ["Meal Prep Reviews", "Healthy Eating", "DFW Delivery Guides"],
    social: {
      instagram: "https://instagram.com/dfwfitmeals",
    },
  },
};

// Map author display names to author IDs
export function getAuthorId(displayName) {
  const map = {
    "Chef Marcus": "chef-marcus",
    "Chef Marcus Thompson": "chef-marcus",
    "Coach Sarah": "coach-sarah",
    "Sarah Mitchell": "coach-sarah",
    "Sarah Mitchell, NASM-CNC": "coach-sarah",
    "Fit Pro Meals Editorial Team": "editorial-team",
    "DFW Fit Meals Editorial": "editorial-team",
    "Fit Pro Meals Team": "fit-pro-meals-team",
    "DFW Fit Meals Team": "fit-pro-meals-team",
  };
  return map[displayName] || "editorial-team";
}
